"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _valueMap = _interopRequireDefault(require("../../../azalea/utils/valueMap"));
var _theme = _interopRequireDefault(require("./theme"));
var _constants = require("../../utils/constants");
var _templateObject, _templateObject2, _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // eslint-disable-next-line no-restricted-imports
var VALID_SIZES = ['small', 'medium', 'large'];
var size = (0, _valueMap["default"])(VALID_SIZES, 'size');
var flavorStyles = function flavorStyles(flavor) {
  return _theme["default"][flavor] || {};
};

/*

Code taken from here: https://projects.lukehaas.me/css-loaders/
and adapted for styled-components

*/

var rotate = (0, _styledComponents.keyframes)(["0%{-webkit-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg);}"]);
var foregroundColor = function foregroundColor(props) {
  return (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    props.foregroundColor || flavorStyles(props.flavor).foregroundColor
  );
};
var backgroundColor = function backgroundColor(props) {
  return (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    props.backgroundColor || flavorStyles(props.flavor).backgroundColor
  );
};
var LoadingSpinner = _styledComponents["default"].div.attrs(function (props) {
  return _objectSpread({}, (0, _constants.getDataProvidesProps)(props));
}).withConfig({
  displayName: "loading_spinner__LoadingSpinner"
})(["display:inline-block;", " ", " ", " position:relative;text-indent:-9999em;border-top:0.5em solid ", ";border-right:0.5em solid ", ";border-bottom:0.5em solid ", ";border-left:0.5em solid ", ";transform:translateZ(0);animation:", " 1.1s infinite linear;&,&:after{border-radius:50%;width:5em;height:5em;}"], size.small(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["font-size: 3px;"]))), size.medium(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["font-size: 6px;"]))), size.large(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["font-size: 20px;"]))), backgroundColor, backgroundColor, backgroundColor, foregroundColor, rotate);
LoadingSpinner.displayName = 'LoadingSpinner';
LoadingSpinner.defaultProps = {
  size: 'large',
  flavor: 'green',
  'data-provides': 'loading-spinner'
};
var _default = exports["default"] = LoadingSpinner;